export default "__VITE_ASSET__Cgqvj1hM__"